export default __webpack_public_path__ + "static/media/orange.bdcda693.svg";